import { createPluginCSSVar } from '../utils';
import { PLUGIN_NAME } from './constants';

export function createCSSVar(name: string) {
  return createPluginCSSVar(PLUGIN_NAME, name);
}
